export const CANCELED = '@collection/CANCELED' as const;

export const REQUEST_SENT = '@collection/REQUEST_SENT' as const;
export const REQUEST_RESOLVED = '@collection/REQUEST_RESOLVED' as const;
export const REQUEST_REJECTED = '@collection/REQUEST_REJECTED' as const;

export const NEW_ITEM = '@collection/NEW_ITEM' as const;
export const ITEM_CREATED = '@collection/ITEM_CREATED' as const;
export const ITEM_UPDATED = '@collection/ITEM_UPDATED' as const;
export const ITEM_REMOVED = '@collection/ITEM_REMOVED' as const;
export const ITEM_FOCUSED = '@collection/ITEM_FOCUSED' as const;

export const ITEM_INSERTED = '@collection/ITEM_INSERTED' as const;
export const ITEM_REPLACED = '@collection/ITEM_REPLACED' as const;
export const ITEM_FLUSHED = '@collection/ITEM_FLUSHED' as const;
export const ITEM_PRUNED = '@collection/ITEM_PRUNED' as const;

export const CHILD_MOVED = '@collection/CHILD_MOVED' as const;

export type CollectionActionType =
  | typeof CANCELED
  | typeof REQUEST_SENT
  | typeof REQUEST_RESOLVED
  | typeof REQUEST_REJECTED
  | typeof NEW_ITEM
  | typeof ITEM_CREATED
  | typeof ITEM_UPDATED
  | typeof ITEM_REMOVED
  | typeof ITEM_FOCUSED
  | typeof ITEM_INSERTED
  | typeof ITEM_REPLACED
  | typeof ITEM_FLUSHED
  | typeof ITEM_PRUNED
  | typeof CHILD_MOVED;
